import { cn } from "@/lib/utils";

const ASSET = "/icons/file-format";

// Figma fileFormat_img 의 종이 결 광택. 레이어가 SVG 가 아니라 각도 그라데이션이라 그대로 옮긴다
const DSD_PAPER_SHEEN = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 30' preserveAspectRatio='none'><g transform='matrix(1.55 -2.1 2.4513 1.8093 12 11.5)'><foreignObject x='-116.44' y='-116.44' width='232.88' height='232.88'><div xmlns='http://www.w3.org/1999/xhtml' style='background-image: conic-gradient(from 90deg, rgb(255, 255, 255) 0%, rgba(231, 243, 255, 0.79) 3.0916%, rgba(207, 231, 255, 0.58) 6.1832%, rgba(231, 243, 255, 0.79) 53.092%, rgb(255, 255, 255) 100%); opacity:0.7; height: 100%; width: 100%;'></div></foreignObject></g></svg>")`;

// img 는 inset 만으로 늘어나지 않으므로 박스는 div 가 잡고 img 는 채운다
const Layer = ({ src, className }: { src: string; className: string }) => (
  <div className={cn("absolute", className)}>
    <img
      alt=""
      src={src}
      className="absolute inset-0 block size-full max-w-none"
    />
  </div>
);

const DsdIcon = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "relative size-10 drop-shadow-[0px_1px_2px_rgba(0,0,0,0.25)]",
      className,
    )}
  >
    <div className="absolute inset-[12.5%_15%_12.5%_10%]">
      <div className="absolute inset-[0_6.67%_0_13.33%] rounded-[4.167px_2.5px_2.5px_4.167px] bg-white" />
      <div
        className="absolute inset-[0_6.67%_0_13.33%] rounded-[4.167px_2.5px_2.5px_4.167px]"
        style={{ backgroundImage: DSD_PAPER_SHEEN }}
      />
    </div>
    <Layer
      src={`${ASSET}/dsd-label.svg`}
      className="inset-[45%_32.5%_20%_7.5%]"
    />
    <Layer
      src={`${ASSET}/dsd-label-shade.svg`}
      className="inset-[45%_32.5%_20%_7.5%]"
    />
    <Layer
      src={`${ASSET}/dsd-label-text.svg`}
      className="inset-[53.75%_40%_29.55%_15.48%]"
    />
    <div className="absolute top-[27.5%] right-[10%] bottom-[32.5%] left-1/2">
      <Layer
        src={`${ASSET}/dsd-badge.svg`}
        className="inset-[-12.5%_-25%_-37.5%_-25%]"
      />
    </div>
  </div>
);

const XbrlIcon = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "relative size-10 overflow-clip drop-shadow-[0px_0px_2px_rgba(0,0,0,0.2)]",
      className,
    )}
  >
    <Layer
      src={`${ASSET}/xbrl-page.svg`}
      className="inset-[12.5%_15%_12.5%_10%]"
    />
    <Layer
      src={`${ASSET}/xbrl-badge.svg`}
      className="inset-[47.5%_2.5%_2.5%_47.5%]"
    />
  </div>
);

export type FileFormat = "dsd" | "xbrl" | "excel" | "dsd-xbrl";

/** Figma `fileFormat_img` — 파일 형식 아이콘. 기본 40px, 크기는 className 으로 바꾼다. */
export const FileFormatIcon = ({
  format,
  className,
}: {
  format: FileFormat;
  className?: string;
}) => {
  if (format === "dsd")
    return <DsdIcon className={cn("shrink-0", className)} />;
  if (format === "xbrl")
    return <XbrlIcon className={cn("shrink-0", className)} />;
  if (format === "excel")
    return (
      <img
        alt=""
        src={`${ASSET}/excel.svg`}
        className={cn("size-10 shrink-0", className)}
      />
    );
  // XBRL 위에 DSD 가 겹친 모양. 각각 30px 로 줄여 좌상·우하로 어긋나게 둔다
  return (
    <div className="relative size-10 shrink-0">
      <XbrlIcon className="absolute top-0 left-[-1px] size-[30px]" />
      <DsdIcon className="absolute top-[10px] left-[11px] size-[30px] drop-shadow-[-1px_1px_2px_rgba(0,0,0,0.25)]" />
    </div>
  );
};
